import {Article} from './article';
import {PricingItem} from './pricing-item';

export abstract class AbstractDevicePricingItem extends PricingItem {
    public device?: Article;
}
